import { Image, Menu, MenuButton, MenuItem, MenuList, useDisclosure } from '@chakra-ui/react'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { setDefaultBillingInfo } from '../../../../../../api/billing'
import { AuthContext } from '../../../../../../AuthProvider'
import { SuccessModal } from '../../../../../../modals/SuccessModal/SuccessModal'

import threeDots from '../../../../../../assets/three_dots.svg'
import { EditVehicleModal } from '../../../EditVehicleModal/EditVehicleModal'
import { DeleteVehicleModal } from '../../../DeleteVehicleModal/DeleteVehicleModal'

export const OptionsSelector = ({ licensePlate, info }) => {
  const { t } = useTranslation()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const { isOpen: isOpenDP, onOpen: onOpenDP, onClose: onCloseDP } = useDisclosure()
  const { isOpen: isOpenSM, onOpen: onOpenSM, onClose: onCloseSM } = useDisclosure()

  return (
    <>
      <Menu>
        <MenuButton padding='0 8px' aria-label='Options' variant='outline'>
          <Image src={threeDots} />
        </MenuButton>
        <MenuList>
          <MenuItem onClick={onOpen}>{t('billing_information.edit')}</MenuItem>
          <MenuItem onClick={onOpenDP}>{t('common.delete')}</MenuItem>
        </MenuList>
      </Menu>
      <EditVehicleModal licensePlate={licensePlate} info={info} onOpen={onOpen} onClose={onClose} isOpen={isOpen} />
      <DeleteVehicleModal
        licensePlate={licensePlate}
        onOpen={onOpenDP}
        onClose={onCloseDP}
        isOpen={isOpenDP}
        onOpenSM={onOpenSM}
      />
      <SuccessModal onOpen={onOpenSM} onClose={onCloseSM} isOpen={isOpenSM} description={t('demo.vehicle_deleted')} />
    </>
  )
}
